/**
 * There is no standard for viewport sizes, so these are just some arbitrary sizes
 * that are commonly used. Sizes are in pixels.
 * E.g. iPhone 17 has a width of ~400px.
 * Note: these should match with the sizes in _viewport-sizes.scss
 *
*/
export const SCREEN_SIZE = {
	SMALL: 400,
	MEDIUM: 768,
	LARGE: 1100,
};
